// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".hero_3MILD{position:relative}.memberList_zNR8I{position:absolute;top:50%;left:0;-webkit-transform:translateY(-50%);transform:translateY(-50%);width:100%;display:flex;align-items:flex-start;justify-content:center;gap:var(--gutter);padding:0 var(--gutter)}.avatar_H3L8H{width:24vmin;max-width:120px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"hero": "hero_3MILD",
	"memberList": "memberList_zNR8I",
	"avatar": "avatar_H3L8H"
};
module.exports = ___CSS_LOADER_EXPORT___;
